export default __webpack_public_path__ + "static/promo-059411c709ac6a732c9be7c9c8da387a.png";